import styled from "@boseo/shared/styled";

export const StyledSection = styled.section`
    padding: 0 0 20px;
    .swiper {
        &-wrapper {
            align-items: center;
        }
    }
`;
